import Layout from '@/views/iori/layout/Layout'

const BeiJingRouter = [
//  人脸识别
  {
        path: '/accessControl',
        component: Layout,
        redirect: '/accessControl/index',
        children: [
            {
                path: 'index',
                component: () => import('@/views/business/base/access-control')
            },
            {
                path: 'access',
                component: () => import('@/views/business/base/access-control/access')
            },
            {
                path: 'door',
                component: () => import('@/views/business/base/access-control/door')
            }
        ]
    },
    // 运营数据
    {
        path: '/operation',
        component: Layout,
        redirect: '/operation/air',
        children: [
            // 最适空气耗时
            {
                path: 'air',
                component: () => import('@/views/business/base/operation/air/month')
            },
            // 最适空气耗时 - 报警
            {
                path: 'air/alarm/month',
                component: () => import('@/views/business/base/operation/air/alarm/month')
            },
            {
                path: 'air/alarm/year',
                component: () => import('@/views/business/base/operation/air/alarm/year')
            },
            // 最适空气耗时 - 最适空气耗时
            {
                path: 'temperature/month',
                component: () => import('@/views/business/base/operation/temperature/month')
            },
            {
                path: 'temperature/day',
                component: () => import('@/views/business/base/operation/temperature/day')
            },
            {
                path: 'temperature/year',
                component: () => import('@/views/business/base/operation/temperature/year')
            },
            // 最适空气耗时 - 供冷坪效
            {
                path: 'cooling/month',
                component: () => import('@/views/business/base/operation/cooling/month')
            },
            {
                path: 'cooling/year',
                component: () => import('@/views/business/base/operation/cooling/year')
            },
            // 最适空气耗时 - 报警分布
            {
                path: 'alarm/month',
                component: () => import('@/views/business/base/operation/alarm/month')
            },
            {
                path: 'alarm/year',
                component: () => import('@/views/business/base/operation/alarm/year')
            },
            // 出入口
            {
                path: 'traffic/month',
                component: () => import('@/views/business/base/operation/traffic/month')
            },
            {
                path: 'traffic/day',
                component: () => import('@/views/business/base/operation/traffic/day')
            },
            {
                path: 'traffic/year',
                component: () => import('@/views/business/base/operation/traffic/year')
            },
        ]
    },
    // 停车场
    {
        path: '/parkingLotList',
        component: Layout,
        redirect: '/parkingLotList/index',
        children: [
            // 停车场列表
            {
                path: 'index',
                component: () => import('@/views/business/base/parkingLotList')
            },
            {
                path: 'first',
                component: () => import('@/views/business/base/parkingLotList/first')
            }
        ]
    }
]

export default BeiJingRouter
